import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import ErrorBoundary from "./front-end-global-components/components/ErrorBoundary/ErrorBoundary";
import "./index.css";
import store, { persistor } from "./redux/store/store";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { logout } from "./redux/authentication/actions";

if (
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1" &&
  process.env.NODE_ENV === "production"
) {
  Sentry.init({
    dsn: "https://cc4e4d82d9a206558de999800b1056f4@o1092733.ingest.us.sentry.io/4510457932021760",
    sendDefaultPii: true,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      }),
      Sentry.captureConsoleIntegration({ levels: ["error"] })
    ],
    replaysSessionSampleRate:
      import.meta.env.REACT_APP_STAGING === "development" ||
      import.meta.env.REACT_APP_STAGING === "uat"
        ? 1.0
        : 0.1,
    normalizeDepth: 10,
    normalizeMaxBreadth: 2000,
    environment: process.env.REACT_APP_STAGING
  });
}

ReactDOM.render(
  <ErrorBoundary
    userType="patient"
    onClick={() => {
      logout(true);
    }}
    handleComponentDidCatch={(error, errorInfo) => {
      Sentry.captureException(error, {
        tags: { userType: "patient" },
        extra: { fatal: true, code: error.code }
      });
    }}
  >
    <React.StrictMode>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </React.StrictMode>
  </ErrorBoundary>,
  document.getElementById("root")
);

if (window.Cypress) {
  window.store = store;
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register({
    onUpdate: onSWUpdate,
    onSuccess: (_controller, buildNo) => {
      console.log(`Successfully updated and serving build ${buildNo}`);
    }
  });
}

const skipWaitingClearCacheAndReload = async () => {
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data === "FORCE_UPDATE_COMPLETE") {
      window.location.reload();
    }
  });

  navigator.serviceWorker.ready.then((registration) => {
    registration.waiting.postMessage("FORCE_UPDATE");
  });
};

async function onSWUpdate(controller, _force) {
  if (!controller) {
    return;
  }
  const criticalUpdateCard = document.getElementById("critical-update-card");
  criticalUpdateCard.classList.remove("display-none");
  criticalUpdateCard.classList.add("display-block");
  const criticalUpdateButton = document.getElementById(
    "critical-update-confirm-button"
  );
  criticalUpdateButton.addEventListener("click", () =>
    skipWaitingClearCacheAndReload()
  );
}

reportWebVitals();
